import React from 'react';
import Sym from './Sym';

/**
 * Etiqueta de estado. Tonos: neutral (default) · ok · warn · danger · brand.
 * Se usa para estados de empresa, FIEL, suscripción, recibos, etc.
 */
const Badge = ({ tone = 'neutral', icon, className = '', children, ...rest }) => (
  <span
    className={['a2-badge', tone !== 'neutral' ? `a2-badge--${tone}` : '', className]
      .filter(Boolean).join(' ')}
    {...rest}
  >
    {icon ? <Sym name={icon} size={14} /> : null}
    {children}
  </span>
);

export default Badge;
